import API from "Api";
import { generateDynamicEndpoint } from "utils/generalUtils";
import {
  GET_PATIENT_LIST_ENDPOINT,
  CREATE_PATIENT_ENDPOINT,
  DELETE_PATIENT_ENDPOINT,
  UPDATE_PATIENT_ENDPOINT,
  GET_SINGLE_PATIENT_ENDPOINT,
  GET_SURGERY_FIELD_ENDPOINT,
  GET_PHARMACY_FIELD_ENDPOINT,
  GET_DRUG_FIELD_ENDPOINT,
  GET_GROUP_FIELD_ENDPOINT,
  PATIENT_URGENCY_STATUS_CHANGE,
  GET_PATIENT_NOTE_LIST_ENDPOINT,
  CREATE_PATIENT_NOTE_ENDPOINT,
  UPDATE_PATIENT_NOTE_ENDPOINT,
  DELETE_PATIENT_NOTE_ENDPOINT,
  GET_SINGLE_PATIENT_NOTE_ENDPOINT,
  GET_PATIENT_MEDICATION_HISTORY_LIST_ENDPOINT,
  IMPORT_CSV_ENDPOINT,
  IMPORT_CSV_LIST_ENDPOINT,
  DELETE_MULTIPLE_AND_SINGLE_CSV_LIST_ENDPOINT,
  UPDATE_PATIENT_FIELD_ENDPOINT,
  ARCHIVE_MEDICATION,
  PROFILEUPDATE,
  PATIENT_DELETE_MULTIPLE,
  IMPORT_PATIENT_DUPLICATE,
  IMPORT_DELETE_DUPLICATE,
  PATIENT_DELETE_COUNT, 
  GET_DRUG_LIST_ENDPOINT
} from "./endpoints";

//Get patient List
export const getPatientListAPI = (payload) => {
  return API.post(GET_PATIENT_LIST_ENDPOINT, payload);
};

// Create patient
export const createPatientAPI = (payload) => {
  return API.post(CREATE_PATIENT_ENDPOINT, payload);
};

//Update patient
export const updatePatientAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_PATIENT_ENDPOINT, { patient_id: id }),
    payload
  );
};
export const updatePatientFieldAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_PATIENT_FIELD_ENDPOINT, { id: id }),
    payload
  );
};

//Single patient list
export const getSinglePatient = (id) => {
  return API.get(
    generateDynamicEndpoint(GET_SINGLE_PATIENT_ENDPOINT, { patient_id: id })
  );
};

//Delete patient
export const deletePatientAPI = (id) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_PATIENT_ENDPOINT, { patient_id: id })
  );
};

//Surgery List
export const getSurgeryFieldListAPI = (payload) => {
  return API.post(GET_SURGERY_FIELD_ENDPOINT, payload);
};

//Pharmacy List
export const getPharmacyListAPI = (payload) => {
  return API.post(GET_PHARMACY_FIELD_ENDPOINT, payload);
};

//Drug Field List
export const getDrugListAPI = (payload) => {
  return API.post(GET_DRUG_FIELD_ENDPOINT, payload);
};

//Group Field List
export const getGroupFieldListAPI = (payload) => {
  return API.post(GET_GROUP_FIELD_ENDPOINT, payload);
};

//Update Urgency
export const patientUrgencyStatus = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(PATIENT_URGENCY_STATUS_CHANGE, { patient_id: id }),
    payload
  );
};

//Get patient note List
export const getPatientNoteListAPI = (payload) => {
  return API.post(GET_PATIENT_NOTE_LIST_ENDPOINT, payload);
};

// Create patient note
export const createPatientNoteAPI = (payload) => {
  return API.post(CREATE_PATIENT_NOTE_ENDPOINT, payload);
};

//Update patient note
export const updatePatientNoteAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_PATIENT_NOTE_ENDPOINT, { patient_id: id }),
    payload
  );
};

//Delete patient note
export const deletePatientNoteAPI = (id) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_PATIENT_NOTE_ENDPOINT, { patient_id: id })
  );
};

//Single patient note list
export const getSinglePatientNote = (id, payload) => {
  return API.get(
    generateDynamicEndpoint(GET_SINGLE_PATIENT_NOTE_ENDPOINT, {
      patient_id: id,
    }),
    payload
  );
};

//Patient medication history
export const getPatientMedicationHistoryAPI = (id, payload) => {
  return API.post(
    generateDynamicEndpoint(GET_PATIENT_MEDICATION_HISTORY_LIST_ENDPOINT, {
      patient_id: id,
    }),
    payload
  );
};

export const getDrugsListAPIFromDND = async (payload) => {
  // var formdata = new FormData();
  // formdata.append("request_type", "drugs");
  // formdata.append("page", payload?.page || 1);
  // if (
  //   payload?.search !== null &&
  //   payload?.search !== undefined &&
  //   payload?.search !== ""
  // ) {
  //   formdata.append("search", payload?.search);
  // }
  // var requestOptions = {
  //   method: "POST",
  //   "Access-Control-Allow-Origin": "origin",
  //   body: formdata,
  // };

  // console.log("process.env.REACT_APP_API_BASE_URL + GET_DRUG_LIST_ENDPOINT", process.env.REACT_APP_API_BASE_URL + GET_DRUG_LIST_ENDPOINT);
  
  // const tempData = await fetch(
  //   process.env.REACT_APP_PHARMSMART_DRUGS_API,
  //   requestOptions
  // )
  //   .then((response) => response.json())
  //   .then((result) => {
  //     return { success: true, data: result.data.results } || {};
  //   })
  //   .catch((error) => error);
  // return tempData;
  return API.post(GET_DRUG_LIST_ENDPOINT, payload);
};

//Import CSV
export function importCSVFile(formData) {
  return API.postWithFormData(IMPORT_CSV_ENDPOINT, formData);
}

//Import List
export const getImportListAPI = (payload) => {
  return API.post(IMPORT_CSV_LIST_ENDPOINT, payload);
};

//Import List
export const deleteMultipleAndSingleCsvListAPI = (payload) => {
  return API.post(DELETE_MULTIPLE_AND_SINGLE_CSV_LIST_ENDPOINT, payload);
};
export const archiveMedicationAPI = (id, payload) => {
  return API.post(
    generateDynamicEndpoint(ARCHIVE_MEDICATION, { id: id }),
    payload
  );
};

export const profileUpdateAPI = (payload) => {
  return API.post(PROFILEUPDATE, payload);
};

export const pateintDeleteMultiple = (payload) => {
  return API.post(PATIENT_DELETE_MULTIPLE, payload);
};

export const getPateintImportDuplicate = (payload) => {
  return API.post(IMPORT_PATIENT_DUPLICATE, payload);
};

export const importDuplicateDelete = (payload) => {
  return API.post(IMPORT_DELETE_DUPLICATE, payload);
};

export const getPatientDeleteCount = (payload) => {
  return API.post(PATIENT_DELETE_COUNT, payload);
};
